import { render } from "./Error.vue?vue&type=template&id=8a97095e&scoped=true"
import script from "./Error.vue?vue&type=script&lang=js"
export * from "./Error.vue?vue&type=script&lang=js"

import "./Error.vue?vue&type=style&index=0&id=8a97095e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\dursu\\Desktop\\projebaum\\güncelbaumind-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a97095e"]])

export default __exports__